<template>
  <div>
    <el-dialog title="选择真实用户"
               :visible.sync="dialogFormVisible"
               width="1600px"
               top="50px"
               :close-on-click-modal="false"
               @close="emitClose"
               @open="open()">
      <!-- <div class="diag"> -->
      <div class="results card">
        <el-form class="search-wrap"
                 ref="searchForm"
                 :inline="true"
                 :model="query">
          <el-form-item label="用户"
                        prop="user_keyword">
            <el-input v-model="query.user_keyword"
                      placeholder="请输入用户ID、昵称或手机号"
                      style="width: 220px"
                      @input="fetchNoteList(true)"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="院校名称"
                        prop="education_college_keyword">
            <el-input v-model="query.education_college_keyword"
                      placeholder="请输入院校关键字代码/名"
                      style="width: 220px"
                      @input="fetchNoteList(true)"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="专业"
                        prop="education_major_keyword">
            <el-input v-model="query.education_major_keyword"
                      placeholder="请输入专业关键字代码/名"
                      style="width: 220px"
                      @input="fetchNoteList(true)"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="学院"
                        prop="education_academy_keyword">
            <el-input v-model="query.education_academy_keyword"
                      placeholder="请输入学院关键字代码/名"
                      style="width: 220px"
                      @input="fetchNoteList(true)"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="科目"
                        prop="education_subject_keyword">
            <el-input v-model="query.education_subject_keyword"
                      placeholder="请输入科目关键字代码/名"
                      style="width: 220px"
                      @input="fetchNoteList(true)"
                      clearable></el-input>
          </el-form-item>
        </el-form>
        <div class="table-header"
             style="display:flex; justify-content:flex-end;">

          <el-form :inline="true"
                   label-width="70px"
                   size="small">
            <el-form-item>
              <el-radio-group v-model="query.user_education_type"
                              @change="tabChange()">
                <el-radio-button v-for="(item, index) in filter.type"
                                 :key="index"
                                 :label="item.value">
                  {{ item.label }}
                </el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </div>
        <div class="values">
          <el-table :data="results"
                    border
                    v-if="query.user_education_type=='2'"
                    style="width: 100%"
                    @selection-change="handleSelectionChange">
            <el-table-column type="selection"
                             width="50"
                             align="center"> </el-table-column>
            <el-table-column prop="id"
                             width="80"
                             label="用户ID"
                             align="center">
            </el-table-column>
            <el-table-column prop="nickname"
                             width="100"
                             label="昵称(身份)"
                             show-overflow-tooltip
                             align="center">
              <template slot-scope="scope">
                <el-link type="primary"
                         @click="handleLookUser(scope.row)">{{ scope.row.nickname? scope.row.nickname :'-'}}</el-link></template>
            </el-table-column>
            <el-table-column prop="id"
                             width="80"
                             label="年份"
                             align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.recruit_info">{{ scope.row.recruit_info.recruit_year}}年</span></template>
            </el-table-column>

            <el-table-column prop="nickname"
                             width="380"
                             label="录取信息"
                             show-overflow-tooltip
                             align="left">
              <template slot-scope="scope">
                <span v-if="scope.row.recruit_info">{{scope.row.recruit_info.recruit_college_name}} | {{scope.row.recruit_info.recruit_academy_name}} |
                  ({{scope.row.recruit_info.recruit_major_code}}){{scope.row.recruit_info.recruit_major_name}} |
                  ({{scope.row.recruit_info.recruit_direction_code}}){{scope.row.recruit_info.recruit_direction_name}}</span></template>
            </el-table-column>
            <el-table-column prop="id"
                             label="当前积分"
                             align="center">
              <template slot-scope="scope">
                <el-link type="primary"
                         @click="handleIntegral(scope.row)">{{ scope.row.overage ?scope.row.overage :0}}分</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="total_author_note_count"
                             label="笔记数量"
                             align="center">
              <template slot-scope="scope">
                <el-link type="primary">{{ scope.row.total_author_note_count ?scope.row.total_author_note_count :0}}个</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="total_author_comment_count"
                             label="评论数量"
                             align="center">
              <template slot-scope="scope">
                <el-link type="primary">{{ scope.row.total_author_comment_count ?scope.row.total_author_comment_count :0}}个</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="total_share_count"
                             label="分享次数"
                             align="center">
              <template slot-scope="scope">
                <el-link type="primary">{{ scope.row.total_share_count ?scope.row.total_share_count :0}}次</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="total_invite_user_count"
                             label="邀请人数"
                             align="center">
              <template slot-scope="scope">
                <el-link type="primary">{{ scope.row.total_invite_user_count ?scope.row.total_invite_user_count :0}}人</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="total_recommend_order_count"
                             label="推荐单数"
                             align="center">
              <template slot-scope="scope">
                <el-link type="primary">{{ scope.row.total_recommend_order_count ?scope.row.total_recommend_order_count :0}}单</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="total_read_order_count"
                             label="付费资料"
                             align="center">
              <template slot-scope="scope">
                <el-link type="primary">{{ scope.row.total_read_order_count ?scope.row.total_read_order_count :0}}单</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="total_video_order_count"
                             label="付费视频"
                             align="center">
              <template slot-scope="scope">
                <el-link type="primary">{{ scope.row.total_video_order_count ?scope.row.total_video_order_count :0}}单</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="total_video_order_count"
                             label="答疑服务"
                             width="140"
                             align="center">
              <template slot-scope="scope">
                <div style="display:flex;align-items:center"> <span class="dot"
                        :style="{'background' :scope.row.answer_card_onoff_status==0 ?' #F56C6C' :'#67C23A'}"></span> <el-link type="primary">{{ scope.row.answer_card_onoff_status==0 ?'关闭中' :'已开启'}}
                  </el-link>
                  <div class="underline"></div>
                  <el-link type="primary">{{ scope.row.total_card_order_count?scope.row.total_card_order_count:0}}单</el-link>
                </div>

              </template>
            </el-table-column>
            <el-table-column prop="total_video_order_count"
                             label="预约1v1"
                             width="140"
                             align="center">
              <template slot-scope="scope">
                <div style="display:flex;align-items:center"> <span class="dot"
                        :style="{'background' :scope.row.tutoring_1v1_onoff_status==0 ?' #F56C6C' :'#67C23A'}"></span> <el-link type="primary">{{ scope.row.tutoring_1v1_onoff_status==0 ?'关闭中' :'已开启'}}
                  </el-link>
                  <div class="underline"></div>
                  <el-link type="primary">{{ scope.row.total_onetoone_order_count?scope.row.total_onetoone_order_count:0}}单</el-link>
                </div>

              </template>
            </el-table-column>
            <el-table-column prop="total_profit_amount"
                             label="累计收益"
                             align="center">
              <template slot-scope="scope">
                <el-link type="primary">{{ scope.row.total_profit_amount ?scope.row.total_profit_amount :0}}元</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="single_cooperate_status"
                             label="是否独家"
                             align="center">
              <template slot-scope="scope">
                <el-image src="https://upload.kaoyanbox.net/130664ae97fee64e5e84acd3ab2c6ca1.png"
                          style="width:16px;height:16px"
                          v-if="scope.row.single_cooperate_status==1"></el-image>
                <span v-else> -</span>
              </template>
            </el-table-column>
            <el-table-column prop="show_status"
                             label="显示状态"
                             align="center">
              <template slot-scope="scope">
                <el-link type="success"
                         v-if="scope.row.show_status==1"
                         @click="handleStatus(scope.row)">展示</el-link>
                <el-link type="info"
                         v-if="scope.row.show_status==2"
                         @click="handleStatus(scope.row)">隐藏</el-link>
                <el-link type="danger"
                         v-if="scope.row.show_status==3"
                         @click="handleStatus(scope.row)">封禁</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="referrer_nickname"
                             label="邀请人"
                             show-overflow-tooltip
                             align="center">
              <template slot-scope="scope">
                <el-link type="primary"
                         v-if="scope.row.referrer_nickname">{{scope.row.referrer_nickname}}</el-link>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="最近发布时间"
                             align="center"
                             width="140"
                             show-overflow-tooltip>
              <template slot-scope="scope">
                {{
                scope.row.last_author_note_time
                  ? $moment(scope.row.last_author_note_time).format("YYYY-MM-DD HH:mm:ss")
                  : "-"
              }}
              </template>
            </el-table-column>
            <el-table-column label="最近分享时间"
                             align="center"
                             width="140"
                             show-overflow-tooltip>
              <template slot-scope="scope">
                {{
                scope.row.last_share_time
                  ? $moment(scope.row.last_share_time).format("YYYY-MM-DD HH:mm:ss")
                  : "-"
              }}
              </template>
            </el-table-column>
            <el-table-column label="最近邀请时间"
                             align="center"
                             width="140"
                             show-overflow-tooltip>
              <template slot-scope="scope">
                {{
                scope.row.last_invite_time
                  ? $moment(scope.row.last_invite_time).format("YYYY-MM-DD HH:mm:ss")
                  : "-"
              }}
              </template>
            </el-table-column>
            <el-table-column label="最近推荐时间"
                             align="center"
                             width="140"
                             show-overflow-tooltip>
              <template slot-scope="scope">
                {{
                scope.row.last_recommend_order_time
                  ? $moment(scope.row.last_recommend_order_time).format("YYYY-MM-DD HH:mm:ss")
                  : "-"
              }}
              </template>
            </el-table-column>
            <el-table-column label="最近登录时间"
                             align="center"
                             width="140"
                             show-overflow-tooltip>
              <template slot-scope="scope">
                {{
                scope.row.note_last_login_time
                  ? $moment(scope.row.note_last_login_time).format("YYYY-MM-DD HH:mm:ss")
                  : "-"
              }}
              </template>
            </el-table-column>
            <el-table-column label="认证提交时间"
                             align="center"
                             width="140"
                             show-overflow-tooltip>
              <template slot-scope="scope">
                {{
                scope.row.senior_apply_create_time
                  ? $moment(scope.row.senior_apply_create_time).format("YYYY-MM-DD HH:mm:ss")
                  : "-"
              }}
              </template>
            </el-table-column>
            <el-table-column label="认证通过时间"
                             align="center"
                             width="140"
                             show-overflow-tooltip>
              <template slot-scope="scope">
                {{
                scope.row.senior_apply_access_time
                  ? $moment(scope.row.senior_apply_access_time).format("YYYY-MM-DD HH:mm:ss")
                  : "-"
              }}
              </template>
            </el-table-column>
            <el-table-column label="注册时间"
                             align="center"
                             width="140"
                             show-overflow-tooltip>
              <template slot-scope="scope">
                {{
                scope.row.register_time
                  ? $moment(scope.row.register_time).format("YYYY-MM-DD HH:mm:ss")
                  : "-"
              }}
              </template>
            </el-table-column>
            <el-table-column label="内部备注"
                             align="center"
                             show-overflow-tooltip>
              <template slot-scope="scope">
                {{
                scope.row.inner_remark
                  ?  scope.row.inner_remark
                  : "-"
              }}
              </template>
            </el-table-column>

          </el-table>

          <el-table :data="results"
                    border
                    v-if="query.user_education_type=='1'"
                    style="width: 100%"
                    @selection-change="handleSelectionChange">
            <el-table-column type="selection"
                             width="50"
                             align="center"> </el-table-column>
            <el-table-column prop="id"
                             width="80"
                             label="用户ID"
                             align="center">
            </el-table-column>
            <el-table-column prop="nickname"
                             width="120"
                             label="昵称"
                             show-overflow-tooltip
                             align="center">
              <template slot-scope="scope">
                <el-link type="primary"
                         @click="handlUserLook(scope.row)">{{ scope.row.nickname? scope.row.nickname :'-'}}</el-link></template>
            </el-table-column>
            <el-table-column prop="id"
                             width="80"
                             label="年份"
                             align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.apply_info">{{ scope.row.apply_info.apply_year !=null ?scope.row.apply_info.apply_year +'年' :'-'}}</span></template>
            </el-table-column>

            <el-table-column prop="nickname"
                             width="350"
                             label="报录信息"
                             show-overflow-tooltip
                             align="left">
              <template slot-scope="scope">
                <div v-if="scope.row.apply_info">
                  <span v-if="scope.row.apply_info.apply_college_name">{{scope.row.apply_info.apply_college_name}}</span>
                  <span v-if="scope.row.apply_info.apply_academy_name"> | {{scope.row.apply_info.apply_academy_name}}</span>
                  <span v-if="scope.row.apply_info.apply_major_code"> | ({{scope.row.apply_info.apply_major_code}}){{scope.row.apply_info.apply_major_name}}</span>
                  <span v-if="scope.row.apply_info.apply_direction_code"> | ({{scope.row.apply_info.apply_direction_code}}){{scope.row.apply_direction_name}}</span>

                </div>

              </template>
            </el-table-column>
            <el-table-column prop="id"
                             width="80"
                             label="当前积分"
                             align="center">
              <template slot-scope="scope">
                <el-link type="primary">{{ scope.row.overage ?scope.row.overage :0}}分</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="total_author_note_count"
                             width="70"
                             label="笔记数量"
                             align="center">
              <template slot-scope="scope">
                <el-link type="primary">{{ scope.row.total_author_note_count ?scope.row.total_author_note_count :0}}个</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="total_author_comment_count"
                             width="70"
                             label="评论数量"
                             align="center">
              <template slot-scope="scope">
                <el-link type="primary">{{ scope.row.total_author_comment_count ?scope.row.total_author_comment_count :0}}个</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="total_order_count"
                             width="70"
                             label="订单数量"
                             align="center">
              <template slot-scope="scope">
                <el-link type="primary">{{ scope.row.total_order_count ?scope.row.total_order_count :0}}个</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="total_order_spend_amount"
                             width="70"
                             label="累计消费"
                             align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.total_order_spend_amount ?scope.row.total_order_spend_amount :0}}元</span>
              </template>
            </el-table-column>
            <el-table-column prop="total_share_count"
                             width="70"
                             label="分享次数"
                             align="center">
              <template slot-scope="scope">
                <el-link type="primary">{{ scope.row.total_share_count ?scope.row.total_share_count :0}}次</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="total_invite_user_count"
                             width="70"
                             label="邀请人数"
                             align="center">
              <template slot-scope="scope">
                <el-link type="primary">{{ scope.row.total_invite_user_count ?scope.row.total_invite_user_count :0}}人</el-link>
              </template>
            </el-table-column>

            <el-table-column prop="total_recommend_order_count"
                             width="70"
                             label="推荐单数"
                             align="center">
              <template slot-scope="scope">
                <el-link type="primary">{{ scope.row.total_recommend_order_count ?scope.row.total_recommend_order_count :0}}单</el-link>
              </template>
            </el-table-column>

            <el-table-column prop="total_profit_amount"
                             width="70"
                             label="累计收益"
                             align="center">
              <template slot-scope="scope">
                <el-link type="primary">{{ scope.row.total_profit_amount ?scope.row.total_profit_amount :0}}元</el-link>
              </template>
            </el-table-column>

            <el-table-column prop="referrer_nickname"
                             width="120"
                             label="邀请人"
                             show-overflow-tooltip
                             align="center">
              <template slot-scope="scope">
                <el-link type="primary"
                         v-if="scope.row.referrer_nickname">{{scope.row.referrer_nickname}}</el-link>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="最近发布时间"
                             align="center"
                             width="100"
                             show-overflow-tooltip>
              <template slot-scope="scope">
                {{
                scope.row.last_author_note_time
                  ? $moment(scope.row.last_author_note_time).format("YYYY-MM-DD")
                  : "-"
              }}
              </template>
            </el-table-column>
            <el-table-column label="最近分享时间"
                             align="center"
                             width="100"
                             show-overflow-tooltip>
              <template slot-scope="scope">
                {{
                scope.row.last_share_time
                  ? $moment(scope.row.last_share_time).format("YYYY-MM-DD")
                  : "-"
              }}
              </template>
            </el-table-column>
            <el-table-column label="最近邀请时间"
                             align="center"
                             width="100"
                             show-overflow-tooltip>
              <template slot-scope="scope">
                {{
                scope.row.last_invite_time
                  ? $moment(scope.row.last_invite_time).format("YYYY-MM-DD")
                  : "-"
              }}
              </template>
            </el-table-column>
            <el-table-column label="最近推荐时间"
                             align="center"
                             width="100"
                             show-overflow-tooltip>
              <template slot-scope="scope">
                {{
                scope.row.last_recommend_order_time
                  ? $moment(scope.row.last_recommend_order_time).format("YYYY-MM-DD")
                  : "-"
              }}
              </template>
            </el-table-column>
            <el-table-column label="最近登录时间"
                             align="center"
                             width="100"
                             show-overflow-tooltip>
              <template slot-scope="scope">
                {{
                scope.row.note_last_login_time
                  ? $moment(scope.row.note_last_login_time).format("YYYY-MM-DD")
                  : "-"
              }}
              </template>
            </el-table-column>

            <el-table-column label="注册时间"
                             align="center"
                             width="100"
                             show-overflow-tooltip>
              <template slot-scope="scope">
                {{
                scope.row.register_time
                  ? $moment(scope.row.register_time).format("YYYY-MM-DD")
                  : "-"
              }}
              </template>
            </el-table-column>
            <el-table-column label="注册来源"
                             align="center"
                             width="100"
                             show-overflow-tooltip>
              <template slot-scope="scope">
                {{
                scope.row.register_source_id
                  ?  scope.row.register_source_id
                  : "-"
              }}
              </template>
            </el-table-column>
            <el-table-column label="内部备注"
                             align="center"
                             width="100"
                             show-overflow-tooltip>
              <template slot-scope="scope">
                {{
                scope.row.inner_remark
                  ?  scope.row.inner_remark
                  : "-"
              }}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="footer">
          <el-pagination background
                         layout="total, prev, pager, next, sizes, jumper"
                         :current-page="Number(query.pageIndex)"
                         :page-sizes="[10, 20, 50, 100, 500]"
                         :page-size="Number(query.pageSize)"
                         :total="Number(pageTotal)"
                         @size-change="handleSizeChange"
                         @current-change="handlePageChange"></el-pagination>
          <div class="submit">
            <div class="cancle"
                 @click="emitClose()">取消</div>
            <div class="confirm"
                 @click="submit()">确定</div>
          </div>
        </div>
      </div>

    </el-dialog>

  </div>
</template>
<script>
import { userIdentityList } from '@/api/read'
import { noteUserList } from '@/api/senior'
export default {
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    product_ids: {
      type: Number,
      default: () => {
        return null
      },
    },
    note_type: {
      type: String,
      default: () => {
        return ''
      },
    },
  },
  data() {
    return {
      dialogFormVisible: this.isVisible,
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
        user_education_type: '2',
      },
      results: [],
      pageTotal: 0,
      chooseList: [],
      filter: {
        type: [
          { label: '学长', value: '2' },
          { label: '学员', value: '1' },
        ],
        educate_types: [
          { label: '学员', value: '0' },
          { label: '学长', value: '1' },
        ],
        statistic_types: [
          { label: '最近发布时间倒序', value: '1' },
          { label: '最近分享时间倒序', value: '2' },
          { label: '最近邀请时间倒序', value: '3' },
          { label: '最近推荐时间倒序', value: '4' },
          { label: '最近登录时间倒序', value: '5' },
          { label: '注册时间倒序', value: '6' },
          { label: '当前积分倒序', value: '7' },
          { label: '笔记数量倒序', value: '8' },
          { label: '邀请人数倒序', value: '9' },
          { label: '推荐单数倒序', value: '10' },
          { label: '累计收益倒序', value: '11' },
        ],
        answer_types: [
          { label: '开启', value: '1' },
          { label: '关闭', value: '0' },
        ],
        tutoring_1v1_types: [
          { label: '开启', value: '1' },
          { label: '关闭', value: '0' },
        ],
        single_types: [
          { label: '否', value: '0' },
          { label: '是', value: '1' },
        ],
      },
    }
  },
  watch: {
    isVisible(val) {
      this.dialogFormVisible = val
    },
  },
  methods: {
    reset() {
      this.results = []
      this.pageTotal = 0
      this.query.pageIndex = 1
    },
    tabChange() {
      this.reset()
      this.fetchNoteList(true)
    },
    handleSelectionChange(val) {
      this.chooseList = val
    },
    emitClose() {
      this.$emit('close')
    },
    submit() {
      this.$emit('realChoose', this.chooseList)
      this.emitClose()
    },
    open() {
      this.fetchNoteList()
    },
    // 笔记用户列表
    fetchNoteList(isReset = false) {
      if (isReset) {
        this.$set(this.query, 'pageIndex', 1)
      }
      noteUserList(this.query).then((res) => {
        this.results = res.list || []
        this.pageTotal = res.count
      })
    },

    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchNoteList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchNoteList()
    },
  },
}
</script>
<style  lang="less" scoped>
::v-deep .el-dialog__header {
  background: #ebeef5;
}
// .diag {
//   height: 670px;
.footer {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  .submit {
    display: flex;
    .cancle {
      margin-right: 10px;
      text-align: center;
      width: 56px;
      height: 36px;
      font-size: 14px;
      color: #909399;
      line-height: 36px;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #dcdfe6;
    }
    .confirm {
      font-size: 14px;
      color: #ffffff;
      text-align: center;
      width: 56px;
      height: 36px;
      line-height: 36px;
      background: #409eff;
      border-radius: 4px 4px 4px 4px;
    }
  }
}
// }
</style>